import React, { Component } from 'react';
import { getModeIcon } from '../../Common/Common';

export default class Display_Mp_Cell_Mode extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	render() {
		let img_width = this.props.cell_width / 4;

		let pointInfo = this.props.point_info;

		let modeTemp = null;

		if (pointInfo.hasOwnProperty('mode')) {
			modeTemp = pointInfo.mode;
		}

		return (
			<div style={{ display: modeTemp == null ? 'none' : 'inline-block' }}>
				<img src={getModeIcon(modeTemp)} style={{ width: img_width }} />
			</div>
		)
	}
}